import {NotificationNumberResolver} from "./notification.resolver";
import {RouterModule, Routes} from "@angular/router";
import {CerbaCommonModule} from "@common/cerba-common.module";
import {NgModule} from "@angular/core";
import {CorrespondantTagsResolver} from "./correspondants-tags.resolver";
import {EnsureUserAuthGuard, LogoutAuthGuard} from "@digicerba/common";
import {CerbaPageComponent} from "./cerba.component";
import {HeaderComponent} from "./header/header.component";
import {AccessResolver} from "./check.resolver";
import {
  ICategorieFormulaireWebServiceClient, IDossierBloqueWebServiceClient, IModeleFormulaireWebServiceClient,
} from "@common/resources/resources";
import {ITagsWebServiceClient, IRessourceMultimediaWebServiceClient,
  IConfigComplementDossierWebServiceClient, IServeurResultatsWebServiceClient} from "app/common/resources/resources";
import {ResourceMultimediaPipe} from "app/common/utils/image/resource.multimedia.pipe";
import {FormulaireDematComponent} from "./pages/formulaires/formulaires";
import {
  CategorieModeleFormulaireResolver,
  EnregistrementModeleFormulaireResolver, TagsModeleFormulaireResolver
} from "./pages/admin/gestion-modele/gestion-modele.resolver";
import {DossierBloquesComponent} from "app/pages/cerba/pages/dossier-bloques/dossier-bloques.component";
import {DossierBloquesModeleComponent} from "./pages/admin/dossier-bloques-modele/dossier-bloques-modele.component";
import {EnsureGestionModeleGuard} from "./pages/admin/gestion-modele/gestion-modele.guard";
import {GestionModeleComponent} from "./pages/admin/gestion-modele/gestion-modele.component";
import {UserAdminAuthGuard} from "./pages/admin/admin.guard";
import {FormulaireDematAdminComponent} from "./pages/admin/admin.component";
import {TagsResolver} from "./tags.resolver";
import {ResultatsComponent} from "./pages/admin/dossier-bloques-modele/resultats/resultats.component";
import {InstanceFormulaireResolver} from "app/pages/cerba/pages/formulaires/instance-formulaire.resolver";
import {EnsureGestionInstanceGuard} from "./pages/formulaires/gestion-instance.guard";
import {FiltresComponent} from "./pages/admin/dossier-bloques-modele/filtres/filtres.component";
import {DossierBloquesFiltresComponent} from "app/pages/cerba/pages/dossier-bloques/dossier-bloques-filtres/dossier-bloques-filtres.component";
import {DossierBloquesResultatsComponent} from "app/pages/cerba/pages/dossier-bloques/dossier-bloques-resultats/dossier-bloques-resultat.components";
import { GuestInstanceComponent } from "./pages/guest/instance-guest.component";
import { FormulaireDematValidators } from "@common/validators/formdemat.validator";
import { CorrespondantTagAccessResolver } from "./pages/correspondant-tag-access.resolver";
import { ProfilValideResolver } from "./profil-valide.resolver";

const cerbaRoutes: Routes = [
  {
    path: 'cerba',
    component: CerbaPageComponent,
    canActivate: [EnsureUserAuthGuard],
    resolve: {
      nbAlerts: NotificationNumberResolver,
      access: CorrespondantTagAccessResolver,
      profilValide: ProfilValideResolver,
    },
    children: [
      {
        path: 'admin', component: FormulaireDematAdminComponent,
        canActivate: [UserAdminAuthGuard],
        resolve: {
          categories: CategorieModeleFormulaireResolver,
          tags: TagsModeleFormulaireResolver
        },
        children: [
          {
            path: 'gestion', component: GestionModeleComponent,
          },
          {
            path: 'gestion/:id', component: GestionModeleComponent,
            canActivate: [EnsureGestionModeleGuard],
            resolve: {
              modeleFormulaire: EnregistrementModeleFormulaireResolver,
            }
          },
          {
            path: 'dossier-bloques', component: DossierBloquesModeleComponent
          },
          {
            path: '', redirectTo: 'dossier-bloques', pathMatch: 'full'
          }
        ]
      },
      {
        path: 'dossier-bloques', component: DossierBloquesComponent
      },
      {
        path: 'creation/formulaire/:id', component: FormulaireDematComponent,
        canActivate: [EnsureGestionModeleGuard]
      },
      {
        path: 'modification/formulaire/:id', component: FormulaireDematComponent,
        canActivate: [EnsureGestionInstanceGuard],
        resolve: {
          formulaire: InstanceFormulaireResolver
        }
      },
      {
        path: '', redirectTo: 'dossier-bloques', pathMatch: 'full'
      },
    ]
  },
  {
    path: 'guest/instance/:id', component: GuestInstanceComponent
  },
  {path: 'logout', component: CerbaPageComponent, canActivate: [LogoutAuthGuard]},
  {path: '', redirectTo: 'cerba', pathMatch: 'full'}
];


@NgModule({
  declarations: [
    HeaderComponent,
    CerbaPageComponent,
    FormulaireDematComponent,
    FormulaireDematAdminComponent,
    GestionModeleComponent,
    DossierBloquesModeleComponent,
    DossierBloquesComponent,
    ResultatsComponent,
    FiltresComponent,
    DossierBloquesResultatsComponent,
    DossierBloquesFiltresComponent,
    GuestInstanceComponent
  ],
  imports: [
    CerbaCommonModule,
    RouterModule.forRoot(cerbaRoutes, {useHash: true})
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AccessResolver,
    UserAdminAuthGuard,
    EnsureGestionModeleGuard,
    TagsResolver,
    NotificationNumberResolver,
    CorrespondantTagsResolver,
    ITagsWebServiceClient,
    ICategorieFormulaireWebServiceClient,
    IModeleFormulaireWebServiceClient,
    IRessourceMultimediaWebServiceClient,
    EnregistrementModeleFormulaireResolver,
    TagsModeleFormulaireResolver,
    CategorieModeleFormulaireResolver,
    ResourceMultimediaPipe,
    InstanceFormulaireResolver,
    EnsureGestionInstanceGuard,
    FormulaireDematValidators,
    CorrespondantTagAccessResolver,
    ProfilValideResolver,
    IConfigComplementDossierWebServiceClient,
    IServeurResultatsWebServiceClient,
    IDossierBloqueWebServiceClient,
  ]
})
export class CerbaRoutingModule { }



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/cerba.router.ts